var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',[_c('a',{attrs:{"href":_vm.titleLink,"target":"_blank"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"subtitle text-primary"},[_vm._v(_vm._s(_vm.subtitle))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }